import { CompositeScopedContextProvider as e, CompositeContextProvider as t } from "./P7GR5CS5.js";
import { createStoreContext as r } from "./LMDWO4NN.js";
var o = r(
  [t],
  [e]
), v = o.useContext, x = o.useProviderContext, C = o.ContextProvider, n = o.ScopedContextProvider;
export {
  C as RadioContextProvider,
  n as RadioScopedContextProvider,
  v as useRadioContext,
  x as useRadioProviderContext
};
//# sourceMappingURL=UVUMR3WP.js.map
